import './component.scss'
import 'Images/white_glass.svg'
import 'Images/arrow_down.svg'
import './images/arrow_down_orange.svg'
import 'Components/nurikae/client_search_modal/component'

import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'
import { fetchCurrentVisitor } from 'Src/site/lib/fetchCurrentVisitor.js'

const app = Application.start()

app.register('top-main-visual-client-search', class extends Controller {
  static targets = [
    'prefectureDropdown',
    'prefectureDropdownTrigger',
    'prefectureDropdownMenu',
    'prefectureDropdownLabel',
    'cityDropdown',
    'cityDropdownTrigger', 
    'cityDropdownMenu',
    'cityDropdownLabel',
    'cityList',
    'partTypeDropdown',
    'partTypeDropdownTrigger',
    'partTypeDropdownMenu',
    'partTypeDropdownLabel',
    'submitButton'
  ]

  static classes = [
    'dropdownTriggerActive',
    'dropdownTriggerSelected',
    'dropdownPartTypeTriggerActive',
    'dropdownMenuActive',
    'dropdownArrowOpen',
    'cityItemEnabled',
    'cityItemDisabled'
  ]

  connect() {
    this.setupEventListeners()
    this.loadDefaultValues()
  }

  async loadDefaultValues() {
    try {
      const visitorInfo = await fetchCurrentVisitor()
      if (visitorInfo) {
        await this.setDefaultSearchValues(visitorInfo)
      }
    } catch (error) {
      console.warn('デフォルト値の設定中にエラーが発生しました:', error)
    }
  }

  setupEventListeners() {
    this.prefectureDropdownTriggerTarget.addEventListener('click', () => {
      this.toggleDropdown(this.prefectureDropdownTarget, this.prefectureDropdownMenuTarget)
    })

    this.cityDropdownTriggerTarget.addEventListener('click', () => {
      if (this.cityListTarget.children.length === 0) return
      this.toggleDropdown(this.cityDropdownTarget, this.cityDropdownMenuTarget)
    })

    this.partTypeDropdownTriggerTarget.addEventListener('click', () => {
      this.toggleDropdown(this.partTypeDropdownTarget, this.partTypeDropdownMenuTarget)
    })

    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-controller="top-main-visual-client-search"]')) {
        this.closeAllDropdowns()
      }
    })

    this.submitButtonTarget.addEventListener('click', () => {
      this.handleSearch()
    })

    this.setupDropdownOptions()
  }

  setupDropdownOptions() {
    this.prefectureDropdownMenuTarget.querySelectorAll('.js-dropdown-option').forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation()
        this.selectPrefectureOption(option)
      })
    })

    this.partTypeDropdownMenuTarget.querySelectorAll('.js-dropdown-option').forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation()
        this.selectPartTypeOption(option)
      })
    })
  }

  toggleDropdown(dropdown, menu) {
    const isActive = menu.classList.contains(this.dropdownMenuActiveClass)

    this.closeOtherDropdowns(menu)

    if (isActive) {
      this.closeDropdown(dropdown, menu)
    } else {
      this.openDropdown(dropdown, menu)
    }
  }

  openDropdown(dropdown, menu) {
    const trigger = dropdown.querySelector('[data-top-main-visual-client-search-target*="DropdownTrigger"]')
    const arrow = dropdown.querySelector('.top-main-visual-client-search__dropdown-arrow')

    menu.classList.add(this.dropdownMenuActiveClass)
    trigger.classList.add(this.dropdownTriggerActiveClass)
    arrow.classList.add(this.dropdownArrowOpenClass)

    if (dropdown === this.partTypeDropdownTarget) {
      trigger.classList.add(this.dropdownPartTypeTriggerActiveClass)
    }
  }

  closeDropdown(dropdown, menu) {
    const trigger = dropdown.querySelector('[data-top-main-visual-client-search-target*="DropdownTrigger"]')
    const arrow = dropdown.querySelector('.top-main-visual-client-search__dropdown-arrow')

    menu.classList.remove(this.dropdownMenuActiveClass)
    trigger.classList.remove(this.dropdownTriggerActiveClass)
    arrow.classList.remove(this.dropdownArrowOpenClass)
  }

  closeOtherDropdowns(currentMenu) {
    [this.prefectureDropdownMenuTarget, this.cityDropdownMenuTarget, this.partTypeDropdownMenuTarget].forEach(menu => {
      if (menu !== currentMenu && menu.classList.contains(this.dropdownMenuActiveClass)) {
        const dropdown = menu.closest('.top-main-visual-client-search__dropdown')
        this.closeDropdown(dropdown, menu)
      }
    })
  }

  closeAllDropdowns() {
    [
      [this.prefectureDropdownTarget, this.prefectureDropdownMenuTarget],
      [this.cityDropdownTarget, this.cityDropdownMenuTarget],
      [this.partTypeDropdownTarget, this.partTypeDropdownMenuTarget]
    ].forEach(([dropdown, menu]) => {
      if (menu.classList.contains(this.dropdownMenuActiveClass)) {
        this.closeDropdown(dropdown, menu)
      }
    })
  }

  async selectPrefectureOption(option) {
    this.setSelectedOption(
      this.prefectureDropdownTarget,
      this.prefectureDropdownLabelTarget,
      option.textContent.trim()
    )
    this.closeDropdown(this.prefectureDropdownTarget, this.prefectureDropdownMenuTarget)
    await this.updateCityOptions()
  }

  selectPartTypeOption(option) {
    const partTypeName = option.querySelector('.top-main-visual-client-search__part-type-name')
    this.setSelectedOption(
      this.partTypeDropdownTarget,
      this.partTypeDropdownLabelTarget,
      partTypeName.textContent,
      { partTypeUrl: option.dataset.partTypeUrl }
    )
    this.closeDropdown(this.partTypeDropdownTarget, this.partTypeDropdownMenuTarget)
    this.updateCityOptions()
  }

  selectCityOption(option) {
    this.setSelectedOption(
      this.cityDropdownTarget,
      this.cityDropdownLabelTarget,
      option.textContent,
      { cityId: option.dataset.cityId }
    )
    this.closeDropdown(this.cityDropdownTarget, this.cityDropdownMenuTarget)
  }

  setSelectedOption(dropdown, label, text, dataAttributes = {}) {
    const trigger = dropdown.querySelector('[data-top-main-visual-client-search-target*="DropdownTrigger"]')
    
    label.textContent = text
    trigger.classList.add(this.dropdownTriggerSelectedClass)

    Object.entries(dataAttributes).forEach(([key, value]) => {
      label.dataset[key] = value
    })
  }

  async updateCityOptions() {
    const selectedPrefecture = this.prefectureDropdownLabelTarget.textContent
    const selectedPartType = this.partTypeDropdownLabelTarget.dataset.partTypeUrl

    if (selectedPrefecture === '都道府県') return

    this.resetCityOptions()

    try {
      const cities = await this.fetchCitiesData(selectedPrefecture, selectedPartType)
      this.renderCityOptions(cities)
    } catch (error) {
      console.error('市区町村データの取得に失敗しました:', error)
    }
  }

  resetCityOptions() {
    const citySelectedOption = document.querySelector('.js-city-dropdown-selected')
    
    this.cityDropdownTriggerTarget.classList.remove(this.dropdownTriggerSelectedClass)
    citySelectedOption.dataset.cityId = ''
    this.cityDropdownLabelTarget.textContent = '市区町村'
    this.cityListTarget.innerHTML = ''
  }

  async fetchCitiesData(prefectureName, partTypeUrl) {
    const response = await fetch(`/api/prefecture/${prefectureName}/enable_cities_for_part_type/?part_type_url=${partTypeUrl}`)
    if (!response.ok) {
      throw new Error('市区町村データの取得に失敗しました')
    }
    return response.json()
  }

  renderCityOptions(cities) {
    cities.forEach(city => {
      const option = document.createElement('li')
      option.classList.add('top-main-visual-client-search__city-item', 'js-dropdown-option')
      option.textContent = city.name
      option.dataset.cityId = city.id
      option.dataset.trackingLabel = `top-mv-searchClient-select-city-${city.id}`

      if (city.enabled) {
        option.classList.add(this.cityItemEnabledClass)
        option.addEventListener('click', (e) => {
          e.stopPropagation()
          this.selectCityOption(option)
        })
      } else {
        option.classList.add(this.cityItemDisabledClass)
      }

      this.cityListTarget.appendChild(option)
    })
  }

  async setDefaultSearchValues(visitorInfo) {
    if (!visitorInfo) return

    try {
      if (visitorInfo.last_viewed_part_type) {
        this.setDefaultPartType(visitorInfo.last_viewed_part_type)
      }

      if (visitorInfo.last_viewed_prefecture) {
        await this.setDefaultPrefecture(visitorInfo.last_viewed_prefecture)
      }

      if (visitorInfo.last_viewed_city) {
        await this.setDefaultCity(visitorInfo.last_viewed_city)
      }
    } catch (error) {
      console.warn('デフォルト値の設定中にエラーが発生しました:', error)
    }
  }

  setDefaultPartType(partTypeData) {
    if (!partTypeData) return

    const targetOption = this.findDropdownOption(
      this.partTypeDropdownMenuTarget,
      option => option.dataset.partTypeUrl === partTypeData.url
    )

    if (targetOption) {
      const partTypeName = targetOption.querySelector('.top-main-visual-client-search__part-type-name')
      this.setSelectedOption(
        this.partTypeDropdownTarget,
        this.partTypeDropdownLabelTarget,
        partTypeName.textContent,
        { partTypeUrl: partTypeData.url }
      )
    }
  }

  async setDefaultPrefecture(prefectureData) {
    if (!prefectureData) return

    const targetOption = this.findDropdownOption(
      this.prefectureDropdownMenuTarget,
      option => option.textContent.trim() === prefectureData.name
    )

    if (targetOption) {
      this.setSelectedOption(
        this.prefectureDropdownTarget,
        this.prefectureDropdownLabelTarget,
        prefectureData.name
      )
      await this.updateCityOptions()
    }
  }

  async setDefaultCity(cityData) {
    if (!cityData) return

    // 市区町村オプションが更新された後に該当するcityIdを探す
    const targetOption = this.findDropdownOption(
      this.cityDropdownMenuTarget,
      option => option.dataset.cityId === cityData.id.toString()
    )

    if (targetOption) {
      this.setSelectedOption(
        this.cityDropdownTarget,
        this.cityDropdownLabelTarget,
        cityData.name,
        { cityId: cityData.id }
      )
    }
  }

  findDropdownOption(container, condition) {
    const options = container.querySelectorAll('.js-dropdown-option')
    return Array.from(options).find(condition)
  }

  handleSearch() {
    const selectedPrefecture = document.querySelector('.js-prefecture-dropdown-selected')
    const selectedCity = document.querySelector('.js-city-dropdown-selected')
    const selectedPartType = document.querySelector('.js-partType-dropdown-selected')

    const prefectureName = selectedPrefecture.textContent
    const cityId = selectedCity.dataset.cityId
    const partTypeUrl = selectedPartType.dataset.partTypeUrl
    const isPrefectureSelected = prefectureName !== '都道府県'

    let url
    if (isPrefectureSelected) {
      url = `/area/${prefectureName}`
      if (cityId) {
        url += `/${cityId}`
      } else {
        url += '/part'
      }
    } else {
      url = '/part'
    }
    url += `/${partTypeUrl}`

    this.gaDatalayerPush(prefectureName, selectedCity.textContent, selectedPartType.textContent, url)
    window.location.href = url
  }

  gaDatalayerPush(prefectureName, cityName, partType, url) {
    window.dataLayer = window.dataLayer || []
    const now = new Date()
    const currentTime = now.toISOString().slice(0, 19).replace('T', ' ')
    window.dataLayer.push({
      event: 'topClientSearchClick',
      topClientSearchSelectedOptions: `${partType}, ${prefectureName}, ${cityName}`,
      topClientSearchUrl: url,
      topClientSearchClickCurrentTime: currentTime
    })
  }
})
